import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import { addDoc, arrayUnion, collection, deleteDoc, doc, getDocs, updateDoc } from 'firebase/firestore'
import { auth, db } from '../../firebase/firebase'

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import { 
    Alert,
  Box,
  Button,
  Card, 
  Grid, 
  Icon, 
  IconButton, 
  List, 
  ListItem, 
  ListItemText, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Tooltip, 
  Typography} from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ListaDiagramas from '../../Components/ListaDiagramas';
import ListaColecciones from '../../Components/ListaColecciones';
import ModalColeccion from '../../Components/Alertas/ModalColeccion';



const ColeccionesScreen = () => {
    
    const user = auth.currentUser;
    const navigate = useNavigate();
    const [diagramas, setDiagramas] = useState([])
    
    const [colecciones, setColecciones] = useState([]);
    const [nombreColeccion, setNombreColeccion] = useState('');
    const [colorColeccion, setColorColeccion] = useState('#FF6900')
    const [diagramasColeccion, setDiagramasColeccion] = useState([]);

    const [abrirModal, setAbrirModal] = useState(false);
    const handleClose = () => setAbrirModal(false);

    const [nodosDiagrama, setNodosDiagrama] = useState([]);
    const [lineasDiagrama, setLineasDiagrama] = useState([]);

    const obtenerDiagramas = async() =>{
        try {
        
            const querySnapshot = await getDocs(collection(db, user.uid));
            const arrayData = querySnapshot.docs.map( doc => 
                (
                {idDocumento: doc.id, ...doc.data()}
                ))      
            setDiagramas(arrayData);
            
            } catch (error) {
            
            }
    }
    
    const obtenerColecciones = async() =>{

        let arrayAux = [];

        try {

            const querySnapshot = await getDocs(collection(db, 'colecciones'));
            querySnapshot.docs.forEach( (doc) => {
            if(doc.data().usuario === user.uid){
                arrayAux.push({id: doc.id, ...doc.data()});
            }
            }); 
            setColecciones(arrayAux);
            
        } catch (error) {
            
        }
    }
    
    useEffect(() => {
    
        obtenerDiagramas();
        obtenerColecciones();
    
    }, [])
    
    const editarDiagrama = (id) =>{

        let titulo = '';
        let fecha = '';

        diagramas.forEach((diagrama)=>{
            if(diagrama.idDocumento === id){
                diagrama.nodos.forEach((node)=>{
                    let newNode = JSON.parse(node);
                    /* console.log(newNode); */
                    nodosDiagrama.push(newNode)
                })

                diagrama.lineas.forEach((line)=>{
                    let newLine = JSON.parse(line);
                    /* console.log(newLine) */
                    lineasDiagrama.push(newLine);
                })
                titulo = diagrama.titulo;
                fecha = diagrama.fecha;
            }
        })
    }

    
    
    const eliminarDiagrama = async(id) =>{
        await deleteDoc(doc(db, user.uid, id));
        obtenerDiagramas();
    }
    
    const crearColeccion = async(e) =>{
        setAbrirModal(false);

        e.preventDefault();

        

        await addDoc(collection(db, 'colecciones'),{
          nombre: nombreColeccion,
          usuario: user.uid,
          diagramas: diagramasColeccion,
          color: colorColeccion
        })

        diagramasColeccion.forEach(async(diagrama)=>{
            await updateDoc(doc(db, user.uid, diagrama.idDocumento),{
                coleccion: arrayUnion(nombreColeccion)
            })
        })

        setDiagramasColeccion([]);
        setNombreColeccion('');
        setColorColeccion('#FF6900');
        obtenerColecciones();
        obtenerDiagramas();
        
        window.location.reload(false);
    }
    

    const handleModal = () =>{
        setNombreColeccion('');
        setColorColeccion('#FF6900')
        setAbrirModal(true);
        setDiagramasColeccion([]);
    }

    return (
        <>
            <Box sx={{ marginLeft: "20%", borderBottom: "1px solid", width: "60%", marginTop: "3%" }}>
                <Grid container>
                    <Grid item xs={10} md={10}>
                        <Typography 
                            component="div" 
                            gutterBottom 
                            style={{ color: "#000", fontSize: "35px", fontWeight: 'bold'}}
                        >
                            COLECCIONES
                        </Typography>

                    </Grid>
                </Grid>
            </Box>
            <br/>
            <Box sx={{ marginLeft: "20%", width: '60%', marginTop: '30px' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <ListaColecciones
                        colecciones={colecciones}
                        diagramas={diagramas}
                        obtenerColecciones={obtenerColecciones}
                        nombreColeccion={nombreColeccion}
                        colorColeccion={colorColeccion}
                    />
                </Box>
                { colecciones.length > 0 ?
                    (null)
                    :
                    (
                    <Alert variant="outlined" severity="info">
                        No tienes colecciones creadas!
                    </Alert>
                    )
                }
            </Box>
            <Box sx={{ marginLeft: "20%", width: '60%' }} textAlign='center'>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }} textAlign='center'>
                    <Tooltip title='Agregar Colección'>
                        <IconButton onClick={handleModal} size='large'>
                            <AddCircleIcon
                                fontSize='large'
                                color='primary'
                            />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>

            {abrirModal && (
                <ModalColeccion
                    crearColeccion={crearColeccion}
                    setNombreColeccion={setNombreColeccion}
                    nombreColeccion={nombreColeccion}
                    colorColeccion={colorColeccion}
                    setColorColeccion={setColorColeccion}
                    handleClose={handleClose}
                    abrirModal={abrirModal}
                    diagramas={diagramas}
                    setColecciones={setColecciones}
                    diagramasColeccion={diagramasColeccion}
                />
            )}
        </>
    )
    
}

export default ColeccionesScreen